export default __webpack_public_path__ + "img/satelite-layer-46e55299a8d09f7493aa9bf550a49a1c.png";